// @flow
import BaseLayoutHintRule from "./BaseLayoutHintRule";

import UploadAttributeModel from "../UploadAttributeModel";

import { INITIAL_TOTAL_FILESIZE, MAX_TOTAL_FILESIZE } from "../../../constants";

import type { AttributeType, ILayoutHintRule } from "../../types";
import type AttributeCollection from "../AttributeCollection";
import type AttributeModel from "../AttributeModel";

/**
 * This pattern enables showing the upload file size remaining when uploading resources<br>
 * The rule depends on other attributes with the INITIAL_TOTAL_FILESIZE and MAX_TOTAL_FILESIZE layout hints
 */
class RemainingTotalUploadSize extends BaseLayoutHintRule {
  /**
   */
  static isApplicableForAttribute(attribute: AttributeType): boolean {
    return attribute instanceof UploadAttributeModel;
  }

  /**
   */
  static initAttribute(): ILayoutHintRule {
    return new RemainingTotalUploadSize();
  }

  /**
   */
  processUploadInformation(
    attribute: UploadAttributeModel,
    attributes: AttributeCollection,
  ) {
    const uploadInformationAttributes = attributes.getAttributesByLayoutHint(
      INITIAL_TOTAL_FILESIZE,
      MAX_TOTAL_FILESIZE,
    );

    if (uploadInformationAttributes.length === 2) {
      const firstHasInitialTotalFileSize =
        uploadInformationAttributes[0].layouthint.has(INITIAL_TOTAL_FILESIZE);

      const initialTotalFileSize = firstHasInitialTotalFileSize
        ? uploadInformationAttributes[0].value
        : uploadInformationAttributes[1].value;

      const maxTotalFileSize = firstHasInitialTotalFileSize
        ? uploadInformationAttributes[1].value
        : uploadInformationAttributes[0].value;

      attribute.initialTotalFileSize = initialTotalFileSize;
      attribute.maxTotalFileSize = maxTotalFileSize;
    }
  }

  /**
   * Sets tresholds for initial and maximum upload file size
   */
  process(attribute: AttributeModel, attributes: AttributeCollection): void {
    if (attribute instanceof UploadAttributeModel) {
      this.processUploadInformation(attribute, attributes);
    }
  }
}

export default RemainingTotalUploadSize;
